<template>
	<div>
		<ActionPdfReport
			:data="five_k_report_data.data"
			:meta="five_k_report_data.meta"
		/>
		<div class="ns-audit-report-page text-center">
			<div v-if="pdf_status.loading" class="flex justify-center mt-16">
				<div class="typewriter">
					<div class="slide"><i></i></div>
					<div class="paper"></div>
					<div class="keyboard"></div>
				</div>
			</div>
			<div v-else-if="pdf_status.error" class="flex justify-center mt-16">
				<img
					src="../../assets/images/error-illustration.svg"
					alt=""
					width="250px"
				/>
			</div>
			<div
				v-else-if="pdf_status.success"
				class="flex justify-center flex-col items-center mt-16"
			>
				<img
					src="../../assets/images/successfully_done.svg"
					alt=""
					width="250px"
				/>
				<Button
					button-text="Download again"
					button-type="primary"
					class=""
					@click="downloadFiveKReport(project_id)"
				/>
			</div>
			<p class="mt-8">{{ pdf_status.message }}</p>
		</div>
	</div>
</template>

<script>
import ActionPdfReport from "@/components/UI/pdf/ActionPdfReport.vue";
import { EventBus } from "../../eventBus";
import Button from "../../components/UI/elements/Button.vue";
import formBuilderServices from "../../services/formBuilderServices";
export default {
	name: "GenerateAuditReport",
	components: {
		ActionPdfReport,
		Button,
	},
	data() {
		return {
			five_k_report_data: {},
			is_5k_data_loaded: false,
			project_id: null,
			is_summary_report: false,
			pdf_status: {
				loading: false,
				error: false,
				success: false,
				message: "⏳ Please wait, your report is currently being downloaded...",
				count: 0,
			},
		};
	},
	computed: {
		computedFiveKReportData() {
			let original_data = { ...this.five_k_report_data.project_execution };
			return original_data;
		},
		computedFiveKReportMetaData() {
			let original_data = { ...this.five_k_report_data.meta };
			return original_data;
		},
		computedFiveKReportPreviousData() {
			let original_data = { ...this.five_k_report_data.previous_projects };
			return original_data;
		},
		checkCompany() {
			return JSON.parse(localStorage.getItem("check_company"));
		},
	},
	created() {
		const query = this.$route.query;
		if (query && query.project_id) {
			this.project_id = query.project_id;
			this.downloadFiveKReport(query.project_id);
			if (query.type && query.type === "summary") {
				this.is_summary_report = true;
			}
		} else {
			this.pdf_status.loading = false;
			this.pdf_status.error = true;
			this.pdf_status.message =
				"❌ An error occurred while downloading your report. Please try again.";
			this.$notify.error({
				title: "Error",
				message: "Project ID is missing!",
				duration: 0,
			});
		}
	},
	methods: {
		downloadFiveKReport(id) {
			let payload = { project_execution_id: id };
			this.pdf_status.loading = true;
			this.pdf_status.error = false;
			this.pdf_status.success = false;
			this.pdf_status.message =
				"⏳ Please wait, your report is currently being downloaded...";
			formBuilderServices
				.getActionsPDFreport(payload)
				.then((res) => {
					this.five_k_report_data = JSON.parse(res.data);
					this.is_5k_data_loaded = true;
					this.pdf_status.loading = false;
					this.pdf_status.success = true;
					this.pdf_status.message =
						"✅ Your report has been successfully downloaded!";
					// if(this.is_5k_data_loaded && this.five_k_report_data.project_execution) {
					setTimeout(() => {
						this.$nextTick(() => {
							// this.processPdfDownload();
							EventBus.$emit("loadActionPdfFirst");
						});
					}, 100);

					// }
				})
				.catch((err) => {
					console.error(err);
					this.pdf_status.loading = false;
					this.pdf_status.error = true;
					this.pdf_status.message =
						"❌ An error occurred while downloading your report. Please try again.";
					this.$notify.error({
						title: "Error",
						message: "Something went wrong!",
					});
					this.is_5k_data_loaded = false;
				})
				.finally(() => {});
		},
	},
};
</script>

<style lang="scss" scoped>
.ns-audit-report-page {
	height: 100vh;
	padding: 25px;
}

.typewriter {
	--blue: #5cbbff;
	--blue-dark: #162d72;
	--key: #fff;
	--paper: #eef0fd;
	--text: #00000049;
	--tool: #ffbb00;
	--duration: 3s;
	position: relative;
	-webkit-animation: bounce05 var(--duration) linear infinite;
	animation: bounce05 var(--duration) linear infinite;
}

.typewriter .slide {
	width: 92px;
	height: 20px;
	border-radius: 3px;
	margin-left: 14px;
	transform: translateX(14px);
	background: linear-gradient(var(--blue), var(--blue-dark));
	-webkit-animation: slide05 var(--duration) ease infinite;
	animation: slide05 var(--duration) ease infinite;
}

.typewriter .slide:before,
.typewriter .slide:after,
.typewriter .slide i:before {
	content: "";
	position: absolute;
	background: var(--tool);
}

.typewriter .slide:before {
	width: 2px;
	height: 8px;
	top: 6px;
	left: 100%;
}

.typewriter .slide:after {
	left: 94px;
	top: 3px;
	height: 14px;
	width: 6px;
	border-radius: 3px;
}

.typewriter .slide i {
	display: block;
	position: absolute;
	right: 100%;
	width: 6px;
	height: 4px;
	top: 4px;
	background: var(--tool);
}

.typewriter .slide i:before {
	right: 100%;
	top: -2px;
	width: 4px;
	border-radius: 2px;
	height: 14px;
}

.typewriter .paper {
	position: absolute;
	left: 24px;
	top: -26px;
	width: 40px;
	height: 46px;
	border-radius: 5px;
	background: var(--paper);
	transform: translateY(46px);
	-webkit-animation: paper05 var(--duration) linear infinite;
	animation: paper05 var(--duration) linear infinite;
}

.typewriter .paper:before {
	content: "";
	position: absolute;
	left: 6px;
	right: 6px;
	top: 7px;
	border-radius: 2px;
	height: 4px;
	transform: scaleY(0.8);
	background: var(--text);
	box-shadow: 0 12px 0 var(--text), 0 24px 0 var(--text), 0 36px 0 var(--text);
}

.typewriter .keyboard {
	width: 120px;
	height: 56px;
	margin-top: -10px;
	z-index: 1;
	position: relative;
}

.typewriter .keyboard:before,
.typewriter .keyboard:after {
	content: "";
	position: absolute;
}

.typewriter .keyboard:before {
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	border-radius: 7px;
	background: linear-gradient(135deg, var(--blue), var(--blue-dark));
	transform: perspective(10px) rotateX(2deg);
	transform-origin: 50% 100%;
}

.typewriter .keyboard:after {
	left: 2px;
	top: 25px;
	width: 11px;
	height: 4px;
	border-radius: 2px;
	box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key),
		60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key),
		22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key),
		60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
	-webkit-animation: keyboard05 var(--duration) linear infinite;
	animation: keyboard05 var(--duration) linear infinite;
}

@keyframes bounce05 {
	85%,
	92%,
	100% {
		transform: translateY(0);
	}

	89% {
		transform: translateY(-4px);
	}

	95% {
		transform: translateY(2px);
	}
}

@keyframes slide05 {
	5% {
		transform: translateX(14px);
	}

	15%,
	30% {
		transform: translateX(6px);
	}

	40%,
	55% {
		transform: translateX(0);
	}

	65%,
	70% {
		transform: translateX(-4px);
	}

	80%,
	89% {
		transform: translateX(-12px);
	}

	100% {
		transform: translateX(14px);
	}
}

@keyframes paper05 {
	5% {
		transform: translateY(46px);
	}

	20%,
	30% {
		transform: translateY(34px);
	}

	40%,
	55% {
		transform: translateY(22px);
	}

	65%,
	70% {
		transform: translateY(10px);
	}

	80%,
	85% {
		transform: translateY(0);
	}

	92%,
	100% {
		transform: translateY(46px);
	}
}

@keyframes keyboard05 {
	5%,
	12%,
	21%,
	30%,
	39%,
	48%,
	57%,
	66%,
	75%,
	84% {
		box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key),
			60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key),
			22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key),
			60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
	}

	9% {
		box-shadow: 15px 2px 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key),
			60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key),
			22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key),
			60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
	}

	18% {
		box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key),
			60px 2px 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key),
			22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key),
			60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
	}

	27% {
		box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key),
			60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key),
			22px 12px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key),
			60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
	}

	36% {
		box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key),
			60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key),
			22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 12px 0 var(--key),
			60px 12px 0 var(--key), 68px 12px 0 var(--key), 83px 10px 0 var(--key);
	}

	45% {
		box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key),
			60px 0 0 var(--key), 75px 0 0 var(--key), 90px 2px 0 var(--key),
			22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key),
			60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
	}

	54% {
		box-shadow: 15px 0 0 var(--key), 30px 2px 0 var(--key), 45px 0 0 var(--key),
			60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key),
			22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key),
			60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
	}

	63% {
		box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key),
			60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key),
			22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key),
			60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 12px 0 var(--key);
	}

	72% {
		box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 2px 0 var(--key),
			60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key),
			22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key),
			60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
	}

	81% {
		box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key),
			60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key),
			22px 10px 0 var(--key), 37px 12px 0 var(--key), 52px 10px 0 var(--key),
			60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
	}
}
</style>
